export const FETCH_CREATE_BOARD = 'FETCH_CREATE_BOARD';
export const FETCH_UPDATE_BOARD = 'FETCH_UPDATE_BOARD';
export const FETCH_DELETE_BOARD = 'FETCH_DELETE_BOARD';
export const FETCH_GET_ALL_BOARDS = 'FETCH_GET_ALL_BOARDS';
export const FETCH_GET_ALL_PROJECT_BOARDS = 'FETCH_GET_ALL_PROJECT_BOARDS';
export const FETCH_UPDATE_BOARD_ORDER = 'FETCH_UPDATE_BOARD_ORDER';
export const FETCH_REPORTED_TASKS_BETWEEN_DATES = 'FETCH_REPORTED_TASKS_BETWEEN_DATES';
export const FETCH_TASKS_BETWEEN_DATES = 'FETCH_TASKS_BETWEEN_DATES';
